<template>
  <div>
      <DxForm
        :form-data="formData"
        :items="items"
        :label-location="labelLocation"
        
      >
        <template #form-line-item="{ data: item }">
          <div>
            {{ formData[item.dataField] }}

            <LineItem
              v-model="formData[item.dataField]"
              :fname="item.dataField"
              :modRoute="routeDef"
            />
          </div>
        </template>
        <!-- relate field -->
        <template #form-rlt="{ data: item }">
          <div>
            <DropDataGrid
              v-model="formData[item.dataField]"
              :rRoute="item.editorOptions.relateModule"
            >
            </DropDataGrid>
          </div>
        </template>
        <!-- checkbox grup -->
        <template #form-checkbox-group="{ data: item }">
          <CheckboxGroup v-model="formData[item.dataField]" :checkList="item">
          </CheckboxGroup>
        </template>

         <template #cstm_field="{ data: item }">
          <div>
              <custom-field-types 
              :item = item 
              :prefix="slug"
              :routeDef = routeDef

              v-model="formData[item.dataField]">
              </custom-field-types>
          </div>
      </template>
      </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";

import DropDataGrid from "@/components/DropDataGrid.vue";
import LineItem from "@/components/LineItemCompo.vue";
import CheckboxGroup from "@/components/CstmCheckboxGroup.vue";
import CustomFieldTypes from "@/components/CustomFieldTypes.vue";

export default {
  props: {
    createDef: Array,
    routeDef: String,
    slug:String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxForm,
    LineItem,
    DropDataGrid,
    CheckboxGroup,
    CustomFieldTypes
  },
    watch: {


    },
  data: function () {
    return {
      mode: "create",
      formData: this.modelData,
      labelLocation: "left",
      log: console.log,
      items: this.createDef,
    };
  },

  methods: {
    setData(data, mode) {
      this.mode = mode;
      this.formData = data;
    },
  },
  created: function () {},
  mounted() {
    this.items = this.createDef;
    this.$watch('formData.is_multi_branch',(oldValue,newValue)=>{

      this.$emit("is_multi",oldValue)

    });

     this.$watch('formData.is_gst',(oldValue,newValue)=>{

      this.$emit("is_gst",oldValue)

    });

    // /* def for quickcreate */
    // getQuickCreateOnBoardDef(this.routeDef).then((response) => {

    //     this.items = response.data.results;
    //     console.log("OnboardForm",response);

    // })
    // .catch((error) => {

    // });
  },
};
</script>

<style>
.dx-form .dx-field-item-label {
  font-size: 14px;
  margin-bottom: 0px;
  
}
.dx-field-item-label-text {
  color:#868484;
}
.dx-texteditor{
  margin-left: 30px;
}
.dx-checkbox-icon {
  margin-left: 30px;
}
</style>